import { render, staticRenderFns } from "./infoPrincipal.vue?vue&type=template&id=1593fe80&scoped=true&"
import script from "./infoPrincipal.vue?vue&type=script&lang=js&"
export * from "./infoPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./infoPrincipal.vue?vue&type=style&index=0&id=1593fe80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1593fe80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1593fe80')) {
      api.createRecord('1593fe80', component.options)
    } else {
      api.reload('1593fe80', component.options)
    }
    module.hot.accept("./infoPrincipal.vue?vue&type=template&id=1593fe80&scoped=true&", function () {
      api.rerender('1593fe80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settle-cfnb/infoPrincipal.vue"
export default component.exports